import React, { Component } from 'react'
import { connect } from 'react-redux'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

import BkFlowEditGuestToggle from './layouts/BkFlowEditGuestToggle'
import BkFlowEditGuestSelect from './layouts/BkFlowEditGuestSelect'

import BkFlowEditGuestFieldInputs from './elements/BkFlowEditGuestFieldInputs'
import _ from 'lodash'

if (process.env.REACT_APP_COMPONENT_EDIT_STAY_GUEST_LAYOUT === 'select') {
	require('../../../styles/css/components/edit/guest/bk-flow-edit-stay-guest-select.css')
} else {
	require('../../../styles/css/components/edit/guest/bk-flow-edit-stay-guest-toggle.css')
}

class BkFlowEditGuestField extends Component {

	constructor(props) {
		super(props)
		this.state = {
			guestInputsExpanded: false
		}
	}

	// Handle display of guest inputs
	openGuestInputs = () => {
		this.setState({
			guestInputsExpanded: !this.state.guestInputsExpanded
		})
	}

	closeGuestInputs = () => {
		this.setState({
			guestInputsExpanded: false,
		})
	}

	render() {
		const {
			configData,
			editStayActiveProperty,
			editStayGuestData,
			roomGroup
		} = this.props

		// Window session for query reservation config
		const flowQueryConfig = localStorage.flowQueryConfig ? JSON.parse(localStorage.flowQueryConfig) : null
		let currentProperty = null

		if (
			editStayActiveProperty &&
			flowQueryConfig &&
			flowQueryConfig.supportedProperties
		) {
			currentProperty = flowQueryConfig.supportedProperties.find(function(property) {
				return String(property.hotelCode) === String(editStayActiveProperty)
			})
		}

		const isPropertyCatsEnabled = _.get(currentProperty, 'enableCats', true)
		const isPropertyDogsEnabled = _.get(currentProperty, 'enableDogs', true)
		const isCatsFieldVisible = flowQueryConfig && flowQueryConfig.enableCats && isPropertyCatsEnabled
		const isDogsFieldVisible = flowQueryConfig && flowQueryConfig.enableDogs && isPropertyDogsEnabled

		const hotelLabels = configData.hotel.labels[0]
		const currentGuestData = editStayGuestData[roomGroup]

		let baseClassNames = 'bk-flow-edit-guest__field-toggle row center-xs'
		let currentCats = false
		let currentDogs = false

		// Update cats & dogs values if toggled
		if (currentGuestData && currentGuestData.dogs) {
			currentCats = currentGuestData.dogs
		}

		if (currentGuestData && currentGuestData.cats) {
			currentDogs = currentGuestData.cats
		}

		if (process.env.REACT_APP_COMPONENT_EDIT_STAY_GUEST_LAYOUT === 'select') {
			baseClassNames = 'bk-flow-edit-guest__field-select'
		}

		return (
			<div className="bk-flow-edit-guest__field">
				<button
					aria-label="Guest Select"
					onClick={ () => this.openGuestInputs() }
					className={baseClassNames}
				>
					{ process.env.REACT_APP_COMPONENT_EDIT_STAY_GUEST_LAYOUT === 'select' ?
						<BkFlowEditGuestSelect
							currentGuestData={currentGuestData}
							hotelLabels={hotelLabels}
						/>
					:
						<BkFlowEditGuestToggle
							currentCats={currentCats}
							currentDogs={currentDogs}
							currentGuestData={currentGuestData}
							hotelLabels={hotelLabels}
							isCatsFieldVisible={isCatsFieldVisible}
							isDogsFieldVisible={isDogsFieldVisible}
						/>
					}
				</button>

				<ClickAwayListener onClickAway={ this.closeGuestInputs }>
					<BkFlowEditGuestFieldInputs
						closeGuestInputs={ this.closeGuestInputs }
						guestInputsExpanded={ this.state.guestInputsExpanded }
						isCatsFieldVisible={isCatsFieldVisible}
						isDogsFieldVisible={isDogsFieldVisible}
						roomGroup={ roomGroup }
					/>
				</ClickAwayListener>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration,
	editStayGuestData: state.editStayGuestData,
	editStayActiveProperty: state.editStayPropertyData.activeHotelCode
})

export default connect(mapStateToProps, null)(BkFlowEditGuestField)


// WEBPACK FOOTER //
// ./src/components/edit/guest/BkFlowEditGuestField.js